import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'form-field-float',
  templateUrl: 'form-field-float.component.html',
  styleUrls: ['form-field-float.component.scss']
})
export class FormFieldFloatComponent {
  @Input() field!: any;
  @Input() formGroup!: FormGroup;

  constructor() {
  }

  ngOnInit() {
  }


}
